var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3e%3cpath fill='%239E3039' d='M0 0h1200v600H0'/%3e%3cpath fill='white' d='M0 240h1200v120H0'/%3e%3c/svg%3e";
  export default img;